import axios from 'axios';

export const getBaseUrl = () => {
	if (window.location.host === 'web.redmanagement.se') {
		return 'https://api.web.redmanagement.se';
	} else if (window.location.host === 'redmanagement-dcqmkcxssq-ez.a.run.app') {
		return 'https://redmanagement-api-dcqmkcxssq-ez.a.run.app';
	} else if (window.location.host === 'redmanagement.se') {
		return 'https://api.web.redmanagement.se';
	} else if (window.location.host === 'www.redmanagement.se') {
		return 'https://api.web.redmanagement.se';
	} else if (window.location.host === 'localhost:3000' || window.location.hostname === 'localhost') {
		return 'http://localhost:8000';
	}
	return 'https://api.web.redmanagement.se';
};

const AUTH_REQUIRED_GET_PATHS = ['/post/internalposts', '/post/internalpost', '/subscription/getall'];

const getRequestPath = config => {
	try {
		return new URL(config.url, config.baseURL || window.location.origin).pathname;
	} catch (error) {
		return config.url?.split('?')[0] || '';
	}
};

const shouldAttachAuthHeader = (config, tid) => {
	if (tid == null || config.skipAuth) {
		return false;
	}
	if (config.authRequired) {
		return true;
	}
	if (config.method !== 'get') {
		return true;
	}

	const path = getRequestPath(config);
	return AUTH_REQUIRED_GET_PATHS.some(authPath => path.startsWith(authPath));
};

const axiosClient = axios.create({
	baseURL: getBaseUrl(),
	timeout: 30000,
	'Content-Encoding': 'gzip',
	headers: {
		'Content-Type': 'application/json',
	},
});

axiosClient.interceptors.request.use(
	config => configure(config),
	error => Promise.reject(error)
);

const readTid = () => {
	try {
		const raw = localStorage.getItem('tid');
		if (!raw) {
			return null;
		}
		return JSON.parse(raw);
	} catch (error) {
		return null;
	}
};

const configure = config => {
	config.baseURL = getBaseUrl();
	const tid = readTid();

	if (shouldAttachAuthHeader(config, tid)) {
		config.headers.Authorization = tid;
	}
	if (config.method === 'get') {
		config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	}
	return config;
};

export default axiosClient;
